import { GatewayAPIService } from '../../core/gateway-api.service';
import { Injectable } from '@angular/core';
import { AccountNote } from './AccountNote';

@Injectable({
  providedIn: 'root',
})
export class AccountNotesService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(private api: GatewayAPIService) {}

  public getNotesForLead(leadId: string) {
    return this._doGet({ lead_id: leadId });
  }

  public getNotesForMerchant(merchantId: string) {
    return this._doGet({ merchant_id: merchantId });
  }

  public createMerchantNote(
    merchantId: string,
    noteText: string,
  ): Promise<AccountNote> {
    return this._doUpdate({ merchantId: merchantId, text: noteText }, 'POST');
  }

  public saveMerchantNote(
    noteId: string,
    noteText: string,
  ): Promise<AccountNote> {
    return this._doUpdate({ id: noteId, text: noteText }, 'PUT');
  }

  public deleteMerchantNote(noteId: string): Promise<void> {
    //return this._doUpdate({id:noteId}, "DELETE").then(() => {});
    return this.api.apiCallSane(
      '/note',
      'DELETE',
      this.api.getDefaultHeaders(),
      null,
      { id: noteId },
      this.options,
    );
  }

  private _doGet(data: any): Promise<AccountNote[]> {
    return this.api
      .apiCallSane(
        '/notes',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then((notes: Partial<AccountNote>[]) =>
        notes.map((n) => new AccountNote(n)),
      );
  }

  // private post(data:any): Promise<AccountNote> {

  //     return this.api.apiCallSane(
  //         '/note',
  //         'POST',
  //         this.api.getDefaultHeaders(),
  //         null,
  //         data,
  //         this.options
  //     ).then((res: Partial<AccountNote>) => new AccountNote(res));
  // }

  // private patch(data:any): Promise<AccountNote> {

  //     return this.api.apiCallSane(
  //         '/note',
  //         'PATCH',
  //         this.api.getDefaultHeaders(),
  //         null,
  //         data,
  //         this.options
  //     ).then((res: Partial<AccountNote>) => new AccountNote(res));
  // }

  private _doUpdate(data: any, method: string): Promise<AccountNote> {
    return this.api
      .apiCallSane(
        '/note',
        method,
        this.api.getDefaultHeaders(),
        null,
        data,
        this.options,
      )
      .then((res: Partial<AccountNote>) => new AccountNote(res));
  }
}
